import {GIFT_KEYWORD_PLACEHOLDERS} from './constants';

export const hasGiftKeywords = (items) => {
  const list = items || window.evite_event.gift_keywords;
  if (!list) return false;

  for (let i = 0; i < list.length; i++) {
    const item = list[i];
    if (item?.keyword?.length > 0 || item?.length > 0) {
      return true;
    }
  }
  return false;
};

export function getGiftKeywordPlaceHolder(index) {
  if (index >= 0 && index < GIFT_KEYWORD_PLACEHOLDERS.length)
    return GIFT_KEYWORD_PLACEHOLDERS[index];
  return '';
}

// Selector function to get the gift keywords
export const selectGiftKeywords = (state) => state.giftKeywords;

export function selectEvent(state) {
  return state.eventDetails;
}

// Builds a url that leads to an amazon search for a keyword and has a tag
// from the Gift Keywords experiment
export function getGiftKeywordAmazonSearchLink(keyword) {
  return window.amazon_search_url_template.replace('XXXX', escape(keyword));
}
